export { default, getServerSideProps } from '@/views/UserDashboard';
